export const LANGUAGE_CONST = {
  EN: "en",
  ZH: "zh",
  MS: "ms",
};
